export default defineNuxtRouteMiddleware((to) => {
  if (to.path.startsWith('/customer_enquete/edit/')) {
    const serialnumber = to.params.serialnumber || to.path.split('/').pop();
    if (serialnumber) {
      return navigateTo(`/customer-enquete/${serialnumber}`);
    }
  }
});
